import "core-js/modules/es.array.map";
import React from "react";
import Rail from "web/react/components/rail/rail";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import styles from "./homepage-trend-rail.css";

function HomepageTrendItem(_ref) {
  var item = _ref.item;
  return React.createElement("div", {
    className: styles.homepageTrendItem
  }, React.createElement(LazyLoadImage, {
    className: styles.homepageTrendImg,
    src: item.image_url,
    alt: item.image_alt
  }), React.createElement("a", {
    className: styles.homepageTrendLink,
    href: item.url
  }, item.title));
}

export function HomepageTrendRail(_ref2) {
  var items = _ref2.items;
  return React.createElement(Rail, {
    className: styles.homepageTrendRail,
    analyticsLabel: "homepage_trend_rail",
    title: "",
    railClassName: styles.railClass,
    smallRail: true
  }, items.map(function (item) {
    return React.createElement(HomepageTrendItem, {
      key: item.url,
      item: item
    });
  }));
}

function HomepageTrendRails(_ref3) {
  var sectionTitle = _ref3.sectionTitle,
      mensLinks = _ref3.mensLinks,
      womensLinks = _ref3.womensLinks;
  return React.createElement("div", {
    className: styles.homepageTrendRails
  }, React.createElement("h3", {
    className: styles.homepageTrendTitle
  }, sectionTitle), React.createElement(HomepageTrendRail, {
    items: womensLinks
  }), React.createElement(HomepageTrendRail, {
    items: mensLinks
  }));
}

export default HomepageTrendRails;